<div
  #rteWrapper
  (paste)="handlePaste()"
  [ngClass]="{
    'edit-mode': inlineActive,
    wrap: inline && !readonly,
    'no-toolbar': (hideToolbar && !active) || readonly,
    overflowing: isOverflowing,
    active: active && styleOnActive
  }"
>
  <!-- removing (click)="switchEdit()" from div so that edit mode can be only enable by edit button  -->
  <div [id]="editorId" [hidden]="readonly && isEmpty"></div>
  <div *ngIf="inlineActive && isOverflowing" class="overflowing-tooltip">
    <ui-error-popup>
      {{ 'rte.maxSizeLimitReachedTooltip' | translate }}
    </ui-error-popup>
  </div>
</div>
<ng-container *ngIf="!readonly; else readonlyNoInput">
  <div class="btns-group" *ngIf="inline && inlineActive">
    <ui-button
      class="button-icon btn-submit inline-edit-button"
      [ngClass]="{ 'disable-submit': uploadingImages || this.isOverflowing }"
      (click)="inlineSubmit()"
    >
      <i class="icon-close-edit"></i>
    </ui-button>
    <ui-button class="button-icon btn-cancel inline-edit-button" (click)="inlineCancel()">
      <i class="icon-close"></i>
    </ui-button>
  </div>
</ng-container>
<ng-template #readonlyNoInput>
  <div *ngIf="isEmpty" class="readonly-text">{{ 'rte.readOnlyNoInput' | translate }}</div>
</ng-template>
